<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { startCase } from "lodash";
import { useAuthStore } from "@/stores/authStore";

import BaseButton from "@/base-components/Button/BaseButton.vue";

const authStore = useAuthStore();

const loginLinks = ref<Record<string, string>>({});

onMounted(async () => {
    await authStore.getLoginLinks();
    loginLinks.value = authStore.loginLinks;
});

const titleCase = (str: string) => {
    if (str === "hr") {
        return "HR";
    } else if (str === "it") {
        return "IT";
    }

    return startCase(str);
};

const roleLogin = (link: string) => {
    location.href = link;
};
</script>
<template>
    <div v-if="Object.keys(loginLinks).length > 0" class="grid grid-cols-1 gap-2 mt-4 lg:grid-cols-2 xl:grid-cols-3">
        <BaseButton
            v-for="(link, key) in loginLinks"
            :key="key"
            variant="secondary"
            size="xs"
            :class="[
                'w-full min-h-12',
                link === ''
                    ? 'hidden'
                    : '',
            ]"
            :id="'login_' + key"
            :data-testid="'login_' + key"
            role="button"
            @click="roleLogin(link)"
        >
            Login as {{ titleCase(key.replace("_link", "")) }}
        </BaseButton>
    </div>
</template>